import { DebounceNodeDataSchema } from '@cotera/api';
import type { WorkflowNodeData } from '../types';
import type { WorkflowNodeHydration } from '../workflow-node-base';
import type { WorkflowNodeOutputShapeContext } from '../workflow-node-output-shape';
import { TypedWorkflowNode } from './typed-workflow-node';

/**
 * A debounce node gates execution on history rather than on content: it claims
 * `(key, window)` and either passes the upstream value through (first time in
 * this window) or halts the branch (already claimed).
 *
 * Structurally a filter with memory — it likewise passes its input through
 * untouched, so its output shape mirrors its single predecessor's and anything
 * wired after it keeps its field suggestions.
 */
export class DebounceWorkflowNode extends TypedWorkflowNode<
  typeof DebounceNodeDataSchema
> {
  protected readonly schema = DebounceNodeDataSchema;

  static override create(
    data: WorkflowNodeData,
    hydration: WorkflowNodeHydration
  ): DebounceWorkflowNode {
    return new DebounceWorkflowNode(data, hydration);
  }

  override deriveTypedOutputShape(
    context: WorkflowNodeOutputShapeContext
  ): string | null {
    return context.resolvePredecessorOutputShape?.(this.id) ?? null;
  }
}
